import React, { useState } from 'react';
import { Routes, Route }   from 'react-router-dom';
import { getRoute }        from 'pursuit/routes/routes';
import ExternalRedirects   from 'pursuit/routes/ExternalRedirects';

import PageHeader          from 'layouts/PageHeader';
import PageFooter          from 'layouts/PageFooter';

import HomePage            from 'pages/HomePage';
import AboutUs             from 'pages/AboutUs';
import EventRoutes         from 'pages/Events/EventsRoutes';
import Pricing             from 'pages/Pricing';
import OurTeamRoutes       from 'pages/OurTeam/OurTeamRoutes';
import Contact             from 'pages/Contact';
import CovidWarning        from 'layouts/CovidWarning';
import CovidInformation    from 'pages/CovidInformation';
import VirtualAppointments from 'pages/VirtualAppointments';
import PursuitMovement     from 'pages/PursuitMovement';

export default function Main(props) {
    const [menuOpen, setMenuOpen] = useState(false);

    const doMenuOpen = (state) => {
        setMenuOpen(state);
    };

    const className = `page-content${(menuOpen === true ? ' menu-open' : '')}`;

    return (
        <div className="container--main">
            <CovidWarning />
            <PageHeader menuOpen={menuOpen} />
            <section className={className}>

                <Routes>
                    <Route path={getRoute('home')} element={<HomePage />} />
                    <Route path={`${getRoute('events')}/*`} element={<EventRoutes />} />
                    <Route path={getRoute('aboutUs')} element={<AboutUs />} />
                    <Route path={`${getRoute('ourTeam')}/*`} element={<OurTeamRoutes />} />
                    <Route path={getRoute('pricing')} element={<Pricing />} />
                    <Route path={getRoute('contact')} element={<Contact />} />
                    <Route path={getRoute('virtualAppointments')} element={<VirtualAppointments />} />
                    <Route path={getRoute('pursuitMovement')} element={<PursuitMovement />} />
                    <Route path={getRoute('covidInformation')} element={<CovidInformation />} />

                    <Route path="*" element={<ExternalRedirects />} />
                </Routes>
            </section>
            <PageFooter isMenuOpen={menuOpen} />
        </div>
    )
}
